// components/OgrenciFormModal.js - İl/İlçe seçimi eklenmiş versiyon
import React, { useState, useEffect } from 'react';
import axiosConfig from "../../../../api/axiosConfig";

const OgrenciFormModal = ({
  isOpen,
  onClose,
  onSubmit,
  formData,
  setFormData,
  currentOgrenci,
  companies
}) => {
  // State for cities and districts
  const [sehirler, setSehirler] = useState([]);
  const [ilceler, setIlceler] = useState([]);
  const [loadingSehirler, setLoadingSehirler] = useState(false);
  const [loadingIlceler, setLoadingIlceler] = useState(false);
  
  // Debug: companies prop'unu kontrol et
  console.log('OgrenciFormModal - companies prop:', companies);
  console.log('OgrenciFormModal - companies uzunluğu:', companies ? companies.length : 0);
  
  // Şehirleri yükle
  useEffect(() => {
    if (isOpen) {
      fetchSehirler();
    }
  }, [isOpen]);

  // Şehirler yüklendikten sonra, mevcut şehir adından ID'yi bul
  useEffect(() => {
    if (sehirler.length > 0 && formData.city && !formData.city_id) {
      const foundSehir = sehirler.find(s => s.il_adi === formData.city);
      if (foundSehir) {
        setFormData(prev => ({ ...prev, city_id: foundSehir.id.toString() }));
      }
    }
  }, [sehirler, formData.city]);

  // Şehir değiştiğinde ilçeleri yükle
  useEffect(() => {
    if (formData.city_id) {
      fetchIlceler(formData.city_id);
    } else {
      setIlceler([]);
      setFormData(prev => ({ ...prev, district: '', district_id: null }));
    }
  }, [formData.city_id]);

  // İlçeler yüklendikten sonra, mevcut ilçe adından ID'yi bul
  useEffect(() => {
    if (ilceler.length > 0 && formData.district && !formData.district_id) {
      const foundIlce = ilceler.find(i => i.ilce_adi === formData.district);
      if (foundIlce) {
        setFormData(prev => ({ ...prev, district_id: foundIlce.id.toString() }));
      }
    }
  }, [ilceler, formData.district]);

  const fetchSehirler = async () => {
    setLoadingSehirler(true);
    try {
      const response = await axiosConfig.get('/admin/location/sehirler');
      setSehirler(response.data);
    } catch (error) {
      console.error('Şehirler yüklenirken hata:', error);
    } finally {
      setLoadingSehirler(false);
    }
  };

  const fetchIlceler = async (sehirId) => {
    setLoadingIlceler(true);
    try {
      const response = await axiosConfig.get(`/admin/location/ilceler/${sehirId}`);
      setIlceler(response.data);
    } catch (error) {
      console.error('İlçeler yüklenirken hata:', error);
      setIlceler([]);
    } finally {
      setLoadingIlceler(false);
    }
  };

  const handleSehirChange = (e) => {
    const selectedSehirId = e.target.value;
    const selectedSehir = sehirler.find(s => s.id.toString() === selectedSehirId);

    setFormData({
      ...formData,
      city_id: selectedSehirId, // Sadece frontend'de kullanılır
      city: selectedSehir ? selectedSehir.il_adi : '',
      district: '', // İlçeyi sıfırla
      district_id: null // İlçe ID'sini sıfırla
    });
  };

  const handleIlceChange = (e) => {
    const selectedIlceId = e.target.value;
    const selectedIlce = ilceler.find(i => i.id.toString() === selectedIlceId);
    setFormData({
      ...formData,
      district_id: selectedIlceId,
      district: selectedIlce ? selectedIlce.ilce_adi : ''
    });
  };
  
  if (!isOpen) return null;

  // Telefon formatını uygulayan fonksiyon
  const formatPhoneNumber = (value) => {
    // Sadece rakamları al
    const numbers = value.replace(/\D/g, '');
    
    // Eğer 0 ile başlıyorsa kaldır
    const cleanNumbers = numbers.startsWith('0') ? numbers.slice(1) : numbers;
    
    // Maksimum 10 rakam al
    const limitedNumbers = cleanNumbers.slice(0, 10);
    
    // Formatla: (5XX) XXX XX XX
    if (limitedNumbers.length === 0) return '';
    if (limitedNumbers.length <= 3) return `(${limitedNumbers}`;
    if (limitedNumbers.length <= 6) return `(${limitedNumbers.slice(0, 3)}) ${limitedNumbers.slice(3)}`;
    if (limitedNumbers.length <= 8) return `(${limitedNumbers.slice(0, 3)}) ${limitedNumbers.slice(3, 6)} ${limitedNumbers.slice(6)}`;
    return `(${limitedNumbers.slice(0, 3)}) ${limitedNumbers.slice(3, 6)} ${limitedNumbers.slice(6, 8)} ${limitedNumbers.slice(8, 10)}`;
  };

  // Telefon değişikliklerini handle eden fonksiyon
  const handlePhoneChange = (e, fieldName) => {
    const formatted = formatPhoneNumber(e.target.value);
    setFormData({ ...formData, [fieldName]: formatted });
  };

  // Form submit için telefon numaralarını temizleyen fonksiyon
  const handleFormSubmit = (e) => {
    e.preventDefault();
    
    // Telefon numaralarından sadece rakamları al
    const cleanParentPhone = formData.parent_phone ? formData.parent_phone.replace(/\D/g, '') : '';
    const cleanPhone = formData.phone ? formData.phone.replace(/\D/g, '') : '';
    
    // Veritabanında olmayan alanları çıkar (city_id sadece frontend için)
    const { city_id, ...formDataClean } = formData;
    
    // Temiz telefon numaralarıyla submit et
    const submitData = {
      ...formDataClean,
      parent_phone: cleanParentPhone ? `0${cleanParentPhone}` : '', // Başına 0 ekle
      phone: cleanPhone ? `0${cleanPhone}` : '' // Başına 0 ekle
    };
    
    // Orijinal onSubmit'i çağır (event'i manuel oluştur)
    const fakeEvent = {
      preventDefault: () => {},
      target: { ...e.target }
    };
    
    // formData'yı geçici olarak güncelle
    const originalFormData = { ...formData };
    setFormData(submitData);
    
    // Submit işlemini bir sonraki tick'te yap
    setTimeout(() => {
      onSubmit(fakeEvent);
      // Form kapanmazsa eski haline döndür
      setTimeout(() => {
        if (isOpen) {
          setFormData(originalFormData);
        }
      }, 100);
    }, 0);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-5xl max-h-[95vh] overflow-hidden">
        <div className="bg-gradient-to-r from-indigo-600 to-purple-600 px-6 py-4">
          <h3 className="text-xl font-bold text-white">
            {currentOgrenci ? 'Öğrenci Düzenle' : 'Yeni Öğrenci Ekle'}
          </h3>
        </div>
        
        <form onSubmit={handleFormSubmit} className="p-6 overflow-y-auto max-h-[calc(95vh-80px)]">
          {/* Tarih Bilgileri */}
          <div className="border-b pb-4 mb-4">
            <h4 className="text-sm font-semibold text-gray-700 mb-3 uppercase tracking-wider">
              Tarih Bilgileri
            </h4>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Kayıt Tarihi</label>
                <input
                  type="date"
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                  value={formData.registration_date}
                  onChange={(e) => setFormData({ ...formData, registration_date: e.target.value })}
                />
              </div>
              
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Son İşlem Tarihi</label>
                <input
                  type="date"
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                  value={formData.last_transaction_date}
                  onChange={(e) => setFormData({ ...formData, last_transaction_date: e.target.value })}
                />
              </div>
            </div>
          </div>

          {/* Kişisel Bilgiler */}
          <div className="border-b pb-4 mb-4">
            <h4 className="text-sm font-semibold text-gray-700 mb-3 uppercase tracking-wider">
              Kişisel Bilgiler
            </h4>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Ad Soyad <span className="text-red-500">*</span></label>
                <input
                  type="text"
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  required
                />
              </div>
              
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Email</label>
                <input
                  type="email"
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                />
              </div>
              
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">İl</label>
                <select
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                  value={formData.city_id || ''}
                  onChange={handleSehirChange}
                  disabled={loadingSehirler}
                >
                  <option value="">
                    {loadingSehirler ? 'Yükleniyor...' : 'İl Seçiniz'}
                  </option>
                  {sehirler.map(sehir => (
                    <option key={sehir.id} value={sehir.id}>
                      {sehir.il_adi}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">İlçe</label>
                <select
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                  value={formData.district_id || ''}
                  onChange={handleIlceChange}
                  disabled={!formData.city_id || loadingIlceler}
                >
                  <option value="">
                    {!formData.city_id
                      ? 'Önce İl Seçiniz'
                      : loadingIlceler
                        ? 'Yükleniyor...'
                        : 'İlçe Seçiniz'}
                  </option>
                  {ilceler.map(ilce => (
                    <option key={ilce.id} value={ilce.id}>
                      {ilce.ilce_adi}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">TC Kimlik No</label>
                <input
                  type="text"
                  maxLength="11"
                  placeholder="11 haneli TC kimlik numarası"
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                  value={formData.tc_kimlik_no || ''}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, ''); // Sadece rakam
                    setFormData({ ...formData, tc_kimlik_no: value });
                  }}
                />
              </div>

              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Veli Adı</label>
                <input
                  type="text"
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                  value={formData.parent_name}
                  onChange={(e) => setFormData({ ...formData, parent_name: e.target.value })}
                />
              </div>
              
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Veli Telefon</label>
                <div className="relative">
                  <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-sm text-gray-500">
                    +90
                  </span>
                  <input
                    type="tel"
                    placeholder="(5XX) XXX XX XX"
                    className="w-full pl-12 pr-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                    value={formData.parent_phone}
                    onChange={(e) => handlePhoneChange(e, 'parent_phone')}
                    maxLength="15"
                  />
                </div>
              </div>

              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Telefon</label>
                <div className="relative">
                  <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-sm text-gray-500">
                    +90
                  </span>
                  <input
                    type="tel"
                    placeholder="(5XX) XXX XX XX"
                    className="w-full pl-12 pr-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                    value={formData.phone || ''}
                    onChange={(e) => handlePhoneChange(e, 'phone')}
                    maxLength="15"
                  />
                </div>
              </div>

              <div className="col-span-2">
                <label className="block text-xs font-medium text-gray-600 mb-1">Tam Adres</label>
                <textarea
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                  rows={2}
                  placeholder="Tam adres bilgisi giriniz..."
                  value={formData.tam_adres || ''}
                  onChange={(e) => setFormData({ ...formData, tam_adres: e.target.value })}
                />
              </div>
            </div>
          </div>

          {/* Eğitim Bilgileri */}
          <div className="border-b pb-4 mb-4">
            <h4 className="text-sm font-semibold text-gray-700 mb-3 uppercase tracking-wider">
              Eğitim Bilgileri
            </h4>
            <div className="grid grid-cols-3 gap-4">
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">
                  Sınıf <span className="text-xs text-gray-500">(Birden fazla seçebilirsiniz)</span>
                </label>
                <select
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                  value={Array.isArray(formData.sinif) && formData.sinif.length === 1 ? formData.sinif[0] : ''}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value && !Array.isArray(formData.sinif)) {
                      setFormData({ ...formData, sinif: [value] });
                    } else if (value && Array.isArray(formData.sinif) && !formData.sinif.includes(value)) {
                      setFormData({ ...formData, sinif: [...formData.sinif, value] });
                    }
                  }}
                  multiple={false}
                >
                  <option value="">Seçiniz</option>
                  <option value="Anaokulu">Anaokulu</option>
                  <option value="1">1. Sınıf</option>
                  <option value="2">2. Sınıf</option>
                  <option value="3">3. Sınıf</option>
                  <option value="4">4. Sınıf</option>
                  <option value="5">5. Sınıf</option>
                  <option value="6">6. Sınıf</option>
                  <option value="7">7. Sınıf</option>
                  <option value="8">8. Sınıf</option>
                  <option value="9">9. Sınıf</option>
                  <option value="10">10. Sınıf</option>
                  <option value="11">11. Sınıf</option>
                  <option value="12">12. Sınıf</option>
                  <option value="Mezun">Mezun</option>
                  <option value="Üniversite">Üniversite</option>
                </select>
                
                {/* Seçilen sınıfları göster */}
                {Array.isArray(formData.sinif) && formData.sinif.length > 0 && (
                  <div className="mt-2 flex flex-wrap gap-1">
                    {formData.sinif.map((sinif, index) => {
                      const displayText = sinif === 'Anaokulu' ? 'Anaokulu' :
                                         sinif === 'Mezun' ? 'Mezun' :
                                         sinif === 'Üniversite' ? 'Üniversite' :
                                         `${sinif}. Sınıf`;
                      return (
                        <span
                          key={index}
                          className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800"
                        >
                          {displayText}
                          <button
                            type="button"
                            onClick={() => {
                              const newSinifArray = formData.sinif.filter((s) => s !== sinif);
                              setFormData({ ...formData, sinif: newSinifArray });
                            }}
                            className="ml-1 hover:text-indigo-900"
                          >
                            ×
                          </button>
                        </span>
                      );
                    })}
                  </div>
                )}
              </div>
              
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Okul</label>
                <input
                  type="text"
                  placeholder="Okul adı"
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                  value={formData.okul}
                  onChange={(e) => setFormData({ ...formData, okul: e.target.value })}
                />
              </div>

              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Ders Türü</label>
                <select
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                  value={formData.class_type}
                  onChange={(e) => setFormData({ ...formData, class_type: e.target.value })}
                >
                  <option value="">Seçiniz</option>
                  <option value="Online">Online</option>
                  <option value="Yüz Yüze">Yüz Yüze</option>
                  <option value="Hibrit">Hibrit</option>
                </select>
              </div>
            </div>
          </div>

          {/* Sistem Bilgileri */}
          <div className="border-b pb-4 mb-4">
            <h4 className="text-sm font-semibold text-gray-700 mb-3 uppercase tracking-wider">
              Sistem Bilgileri
            </h4>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Kayıt Edilen Şirket</label>
                <select
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                  value={formData.registered_system}
                  onChange={(e) => setFormData({ ...formData, registered_system: e.target.value })}
                >
                  <option value="">Şirket Seçiniz</option>
                  {companies && companies.length > 0 ? (
                    companies.map(company => (
                      <option key={company.id} value={company.id}>
                        {company.sirket_adi}
                      </option>
                    ))
                  ) : (
                    <option value="" disabled>Yükleniyor...</option>
                  )}
                </select>
              </div>

              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Temsilci</label>
                <input
                  type="text"
                  placeholder="Temsilci adı"
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                  value={formData.representative}
                  onChange={(e) => setFormData({ ...formData, representative: e.target.value })}
                />
              </div>

              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Durum</label>
                <select
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                  value={formData.status}
                  onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                >
                  <option value="1">Aktif</option>
                  <option value="0">Pasif</option>
                </select>
              </div>
              
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Kayıt Durumu</label>
                <select
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                  value={formData.registration_status}
                  onChange={(e) => setFormData({ ...formData, registration_status: e.target.value })}
                >
                  <option value="0">Devam Ediyor</option>
                  <option value="1">Derslere Başladı</option>
                  <option value="2">Vazgeçti</option>
                  <option value="3">Dersler Bitti</option>
                  <option value="4">Ödeme Sorunu</option>
                  <option value="5">Ara Verdi</option>
                </select>
              </div>

              <div className="col-span-2">
                <label className="block text-xs font-medium text-gray-600 mb-1">
                  Parola {currentOgrenci ? '(Boş bırakırsanız değişmez)' : ''}
                  {!currentOgrenci && <span className="text-red-500">*</span>}
                </label>
                <input
                  type="text"
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                  placeholder={currentOgrenci ? "Yeni parola..." : "Parola giriniz..."}
                  value={formData.password}
                  onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                  required={!currentOgrenci}
                />
              </div>
            </div>
          </div>

          {/* Açıklama */}
          <div className="mb-4">
            <label className="block text-xs font-medium text-gray-600 mb-1">Açıklama</label>
            <textarea
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
              rows={2}
              placeholder="Öğrenci hakkında not ekleyebilirsiniz..."
              value={formData.aciklama}
              onChange={(e) => setFormData({ ...formData, aciklama: e.target.value })}
            />
          </div>
          
          {/* Bilgi Mesajı */}
          <div className="p-3 bg-blue-50 rounded-lg mb-4">
            <p className="text-xs text-blue-700">
              ℹ️ Öğrencinin ders ve öğretmen bilgileri <strong>Kurs Satış</strong> modülünden yönetilmektedir.
            </p>
          </div>

          {/* Butonlar */}
          <div className="flex justify-end space-x-3 pt-4 border-t">
            <button
              type="button"
              className="px-5 py-2 text-sm bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors font-medium"
              onClick={onClose}
            >
              İptal
            </button>
            <button
              type="submit"
              className="px-5 py-2 text-sm bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-lg hover:from-indigo-700 hover:to-purple-700 transition-all font-medium shadow-lg"
            >
              {currentOgrenci ? 'Güncelle' : 'Kaydet'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default OgrenciFormModal;